import {injectable} from "inversify";
import {Cart} from "../../../models/cart";

@injectable()
export class CheckoutCartUseCase {
  execute(): Cart {

  }
}
